export default "__VITE_ASSET__da78454b__"